import { Header } from '@components/Header';
import { routes } from '@routes';
import { Helmet } from 'react-helmet-async';

const resources = [
  {
    title: 'Scoping Course',
    description:
      'A Digital Scopist is trained to take rough-draft legal transcripts produced by speech-to-text technology and edit the transcript into a final or near-final-ready version.',
    actions: [{ label: 'Register', href: 'https://thecourtreportingacademy.com/digital-scopist/' }],
  },
  {
    title: 'DCR Course',
    description:
      'A 4-to-6-week self-paced online course with extensive live coaching and instructor interaction. The course is designed to prepare you to successfully pass the AAERT certification exam.',
    actions: [{ label: 'Register', href: 'https://thecourtreportingacademy.com/digital-court-reporting/' }],
  },
  {
    title: 'Extra Resources',
    description:
      'Supplemental training materials to enhance your learning experience, including a full AutoScript video tutorial and self-help documents.',
    actions: [
      { label: 'Full AutoScript Tutorial', href: 'https://youtu.be/kkIPGjXt2vs' },
      {
        label: 'Self Help',
        href: 'https://support.voicescript.ai/portal/en/kb/voicescript-software/autoscript-desktop',
      },
    ],
  },
] as const;

export const TrainingAdditionalResourcesPage = () => (
  <>
    <Helmet>
      <title>Additional Training Resources - AutoScript</title>
    </Helmet>
    <Header title="Additional Training Resources" backRoute={routes.training.make()} />

    <main className="px-4 md:px-[30px] pt-2 pb-[70px] max-w-[1100px]">
      <div className="grid gap-4 md:grid-cols-3">
        {resources.map((resource) => (
          <div
            key={resource.title}
            className="flex flex-col border border-[var(--color-border)] rounded-[8px] bg-[var(--color-surface)] p-5"
          >
            <h3 className="text-base font-semibold text-[var(--color-text)] m-0">{resource.title}</h3>
            <p className="mt-3 mb-5 text-sm leading-[150%] text-[var(--color-text-muted)] flex-1">
              {resource.description}
            </p>
            <div className="flex flex-col gap-2">
              {resource.actions.map((action, index) => (
                <a
                  key={action.href}
                  href={action.href}
                  target="_blank"
                  rel="noreferrer"
                  className={index === 0 ? 'btn w-full justify-center' : 'btn btn--outlined w-full justify-center'}
                >
                  {action.label}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </main>
  </>
);
